<!-- Generator: Adobe Illustrator 28.1.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg enable-background='new 0 0 250 205' height='205px' version='1.1' viewBox='0 0 250 205' width='250px'
     x='0px' xml:space='preserve' xmlns='http://www.w3.org/2000/svg' y='0px'>
<g id="graphics">
	<path d="M171.5,174.5h-4.7h-4.7h-31.6l0,24H123h-7.5l0-24H84.7h-4.8h-4.3
		v-8.9v-15.7v-15.7v-15.7v-15.7V88.5L76,88l0.5-0.5h3.4h0c3.1,0,6,1.2,8.2,3.4l16.1,16.4l14.2,14.5c2.9,3,7.7,3,10.6,0l14.2-14.5
		l16.2-16.5c2.1-2.1,5-3.3,8-3.3h0h3.2L171,88l0.5,0.5v14.3v15.7v15.7v15.7v15.7V174.5z" fill="#9A9A9A" stroke="#707070" stroke-miterlimit="10"/>
  <path d="M175.9,77.7l-45.6,29.6
		c-4.4,2.8-10,2.8-14.3,0L70.4,77.7l4.1-6.2l45.9,28.3c1.7,1.1,3.8,1.1,5.4,0l46-28.5L175.9,77.7z" fill="#DADADA" stroke="#707070" stroke-linejoin="round" stroke-miterlimit="10"/>
  <path d="M86.5,89c0,15,0,30,0,45" fill="none" stroke="#285172" stroke-miterlimit="10"/>
  <line fill="none" stroke="#285172" stroke-miterlimit="10" x1="159.5" x2="159.5" y1="89" y2="134"/>
  <g>
		<g>
			<line fill="none" stroke="#285172" stroke-miterlimit="10" stroke-width="2" x1="150" x2="150" y1="14" y2="43.3"/>
      <g>
				<polygon fill="#285172" points="146,42.1 150,49 154,42.1 				"/>
			</g>
		</g>
	</g>
  <g>
		<g>
			<line fill="none" stroke="#285172" stroke-miterlimit="10" x1="90.6" x2="155.4" y1="128.5" y2="128.5"/>
      <g>
				<polygon fill="#285172" points="91.3,131 87,128.5 91.3,126 				"/>
			</g>
      <g>
				<polygon fill="#285172" points="154.7,131 159,128.5 154.7,126 				"/>
			</g>
		</g>
	</g>
  <g>
		<g>
			<line fill="none" stroke="#285172" stroke-miterlimit="10" x1="57.1" x2="68.1" y1="97.1" y2="81.7"/>
      <g>
				<polygon fill="#285172" points="69.7,83.8 70.1,78.8 65.6,80.9 				"/>
			</g>
		</g>
	</g>
  <g>
		<g>
			<line fill="none" stroke="#285172" stroke-miterlimit="10" x1="87.4" x2="77.9" y1="54.5" y2="68.1"/>
      <g>
				<polygon fill="#285172" points="76.3,66.1 75.9,71.1 80.4,68.9 				"/>
			</g>
		</g>
	</g>
  <path d="M132.5,72.7c-2.5,5.5-5,11-7.5,16.5c-0.8,1.8-2.2,1.8-3,0
		c-2.5-5.5-5-11-7.5-16.5V6.5h18V72.7z" fill="#9A9A9A" stroke="#707070" stroke-miterlimit="10"/>
</g>
  <g id="texts">
	<rect fill="none" height="45" width="97" x="75" y="136.2"/>

    <text fill="#285172" font-family="'OpenSans'" font-size="12px" id="dieWidth" transform="matrix(1 0 0 1 100 145.0303)">{{dieWidth}}</text>
    <rect fill="none" height="30.3" width="90.2" x="156.8" y="24.7"/>

    <text fill="#285172" font-family="'OpenSans'" font-size="12px" id="pressingForce" transform="matrix(1 0 0 1 156.8447 33.5576)">{{pressingForce}}</text>
    <rect fill="none" height="45" width="67.9" x="179.1" y="66.6"/>

    <text fill="#285172" font-family="'OpenSans'" font-size="12px" id="bendingLength" transform="matrix(1 0 0 1 179.084 75.4639)">{{bendingLength}}</text>
    <polygon fill="none" points="68.8,111.1 2.6,111.1 2,66.1 68.1,66.1 	"/>

    <text fill="#285172" font-family="'OpenSans'" font-size="12px" id="sheetWidth" transform="matrix(1 0 0 1 15 74.9639)">{{sheetThickness}}</text>
</g>
</svg>
